import { useContext, useState } from 'react';
import { historyService } from '../../../services/historyService';
import { blockchainService } from '../../../services/blockchainService';

// import { Instructions } from './Instructions';
import ValidateProgress from './ValidateProgress/ValidateProgress';
import { appContext } from '../../../AppContext';
// import {
//   fetchData,
//   paymentProcessing,
//   returnStatus,
// } from '../../../utils/validateprogress/payment';
// import { FeeInfo } from './FeeInfo';
// import { processPendingTransaction } from '../../../utils/txnHelpers';
// import {
//   createBlockchainHistoryRecord,
//   deleteBlockchainRecordsByHash,
//   updateCompletedHistoryRecord,
//   updateHistoryRecord,
//   updateHistoryRecordCancelled,
// } from '../../../services/sql/sqlHelpers';
import { validateFileAPI } from '../../../services/backend';
// import { createBlockchainDataList } from '../../../services/sql/sqlFunctions';

export const Validation = ({
  fee,
  setValidationMsg,
  addingFiles,
  pendingMsg,
  setPendingMsg,
  usrBalance,
  setUsrBalance,
  pendingIsOpen,
  setPendingIsOpen,
  showErrorModal,
  verifyBtnText,
  fileErrors,
  setFileErrors,
  setFee,
  setMintOption,
  mintOption,
}) => {
  const {
    files,
    setFiles,
    validateState,
    setValidateState,
    setValidationLoader,
    validationComplete,
    setValidationComplete,
    setValidationStatus,
    setValidatingFile,
  } = useContext(appContext);

  const initialTxnObj = {
    status: false,
    pending: false,
    pendinguid: 'null',
  };

  const [feeMsg, setFeeMsg] = useState('');
  const [sentTxn, setSentTxn] = useState<IPendingState>(initialTxnObj);
  const [receiveTxn, setReceiveTxn] = useState<IPendingState>(initialTxnObj);
  const [hasCheckedFee, setHasCheckedFee] = useState(false);
  const [hasCheckedNFT, setHasCheckedNFT] = useState(false);
  // FIXME add to context
  const [abortController, setAbortController] = useState<any>(null);

  // useEffect(() => {
  //   fetchData(setFeeMsg, setUsrBalance);
  // }, []);

  // useEffect(() => {
  //   const callback = (e: CustomEvent) => {
  //     const msg = e.detail;

  //     const pending = msg.data.result.pending;
  //     const pendinguid = msg.data.uid;

  //     if (sentTxn.pendinguid === pendinguid) {
  //       const status = msg.data.status;
  //       let coinid;
  //       if (msg.data?.result?.response?.body?.txn?.outputs?.length > 0) {
  //         coinid = msg.data.result.response.body.txn.outputs[0].coinid;
  //       }

  //       // Process the pending transaction
  //       const pendingRes = processPendingTransaction(pending, pendinguid, status, coinid);
  //       setReceiveTxn(pendingRes);
  //     }
  //   };

  //   window.addEventListener('MDS_PENDING', callback as EventListener);

  //   return () => {
  //     window.removeEventListener('MDS_PENDING', callback as EventListener);
  //   };
  // }, [sentTxn]);

  // useEffect(() => {
  //   returnStatus(
  //     fee,
  //     sentTxn,
  //     hasCheckedFee,
  //     setHasCheckedFee,
  //     setPendingIsOpen,
  //     receiveTxn,
  //     files,
  //     setPendingMsg,
  //     setUsrBalance,
  //     setSentTxn,
  //     setValidationMsg,
  //     hasCheckedNFT,
  //     setHasCheckedNFT,
  //     handleDataValidation,
  //   );
  // }, [receiveTxn]);

  // const handlePayment = () => {
  //   if (fee > 0) {
  //     paymentProcessing(setPendingMsg, setPendingIsOpen, setUsrBalance, fee, files, setSentTxn);
  //   } else {
  //     handleDataValidation();
  //   }
  // };

  const handleDataValidation = async (nftData?: string) => {
    // const controller = new AbortController();
    // setAbortController(controller);

    setValidationMsg('');
    setValidateState(true);
    setValidationLoader(true);

    try {
      //Loopa igenom varje fil
      for (let i = 0; i < files.length; i++) {
        // if (controller.signal.aborted) break;
        // Indicate that validation is in progress
        const fileName = files[i].file.name;

        setValidatingFile(fileName);

        //Skicka en req med filen som ska valideras
        // const response = await validateFileAPI(files[i].file, files[i].jsonContent);
        const res = await validateFileAPI(files[i].file, true);
        // console.log('RESPONSE', res);

        const dataRes = res.data.response;
        // console.log('DATARES', dataRes);

        const data = dataRes.data;
        // console.log('DATA', data);

        // TODO remove this, need to remove from backend to work properly
        // const blockData0 = data.blockchain_data?.[0] || null;
        const blockData = data.blockchain_data || null;
        // console.log('BLOCKCHAINDATA', blockData);

        if (dataRes.error) {
          let errorList: any[] = [];

          let error = {
            message: `${dataRes.error}. Please contact support for help.`,
            code: 'API_ERROR',
          };
          errorList.push(error);

          setFileErrors(errorList);
          throw new Error(dataRes.error);
        }
        // console.log('file:', files[i]);
        // Create history record
        const historyData = {
          REQ_ID: res.requestId,
          HASH: dataRes.fileHash,
          FILE_NAME: files[i].file.name,
          VALIDATION_METHOD: data.validationMethod,
          VALIDATION_RESULT: data.result,
          VALID: data.result !== 'no match' ? 1 : 0, // FIXME
          TOKEN_ID: dataRes.nftcoinid || null,
          TOKEN_ID_INDEX: 1, //FIXME
          TOKEN_TXPOW: dataRes?.nfttxnid || null,
          // BLOCK: blockData0?.block_number || null,
          // BLOCK_DATE: blockData0?.block_date || null,
          // TXPOW_ID: blockData0?.txpow_id || null,
          // TRANSACTION_ID: blockData0?.transactionid || null,
        };

        for (const block of blockData) {
          const blockchainData = {
            REQ_ID: res.requestId,
            BLOCK: block?.block_number || null,
            BLOCK_DATE: block?.block_date || null,
            TXPOW_ID: block?.txpow_id || null,
            TRANSACTION_ID: block?.transactionid || null,
            COIN_ID: block?.coin_id || null,
            MATCHED_HASH: block?.matched_hash || null,
          };

          try {
            await blockchainService.create(blockchainData);
          } catch (error) {
            console.error('Failed to create blockchain record:', error);
          }
        }

        try {
          await historyService.createHistory(historyData);
        } catch (error) {
          console.error('Failed to create history record:', error);
        }

        // if (!controller.signal.aborted) {
        //   setFiles((prevFiles) =>
        //     prevFiles.map((file, index) => {
        //       if (index === i) {
        //         return { ...file, validated: true };
        //       }
        //       return file;
        //     }),
        //   );
        //   // await updateCompletedHistoryRecord(response.fileHash, true);
        // }
      }

      // if (controller.signal.aborted) {
      //   setFiles((prevFiles) =>
      //     prevFiles.map((file) => {
      //       if (!file.validated && file.jsonContent) {
      //         // deleteBlockchainRecordsByHash(file.fileHash);
      //         // updateHistoryRecordCancelled(file.fileHash, 2, 'Not validated');
      //         return { ...file, validationMethod: 'timestamp' };
      //       } else if (!file.validated && !file.jsonContent) {
      //         // deleteBlockchainRecordsByHash(file.fileHash);
      //         // updateHistoryRecordCancelled(file.fileHash, 2, 'Not validated');
      //         return { ...file, validationMethod: 'fullfile' };
      //       }

      //       return file;
      //     }),
      //   );
      // }

      // Set file progress to complete
      setFiles((prevFiles) =>
        prevFiles.map((file) => {
          if (file.validated) {
            return { ...file, progress: 'complete' };
          }
          return file;
        }),
      );

      // FIXME update to SQL file validation progress & show in report

      setValidationComplete(true);
    } catch (err: any) {
      setFileErrors([
        {
          message:
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message ||
            'Unknown error, contact support',
          code: 'API_ERROR',
          details: err?.response?.data?.errors?.[0] || null,
        },
      ]);

      // console.log('ERROR IN CATCH', err);
    }
    // LOOP FOR FILE FINISHED
    setFiles([]);
    setValidatingFile('');
    setValidationStatus('');
    setValidateState(false);
    setValidationLoader(false);
    setAbortController(null);
  };

  return (
    <>
      {!showErrorModal && !pendingIsOpen && (
        <>
          {!validateState && (
            <div className="flex flex-col gap-[8px] text-xs">
              {/* {files.length > 0 && (
                <>
                  {!validationComplete && !addingFiles && (
                    <>
                      <FeeInfo fee={fee} addingFiles={addingFiles} />
                    </>
                  )}
                </>
              )} */}
              <p className="text-center text-xs text-core-grey-60 font-semibold">
                If you recently stamped a file, please allow time for the confirmation of the
                stamp(transaction) on chain before verifying that file, up to one minute.
              </p>
              {/* <Instructions /> */}
            </div>
          )}

          <ValidateProgress
            // handlePayment={handlePayment}
            handleDataValidation={handleDataValidation}
            fee={fee}
            abortController={abortController}
            pendingMsg={pendingMsg}
            pendingIsOpen={pendingIsOpen}
            setPendingIsOpen={setPendingIsOpen}
            usrBalance={usrBalance}
            verifyBtnText={verifyBtnText}
            mintOption={mintOption}
          />
        </>
      )}
    </>
  );
};
